import { ROUTER_BLOCKER_STATE_BLOCKED } from '../constants/router'

/**
 * Checks if the blocker is in the 'blocked' state
 * @param {{ state: "unblocked" | "blocked" | "proceeding" }} blocker - the router blocker object
 * @returns {boolean}
 */
export function isRouterBlockerBlocked(blocker) {
  return blocker.state === ROUTER_BLOCKER_STATE_BLOCKED
}
